import { createContext, SetStateAction, Dispatch } from "react";

export type EnvironmentsType = {
    /**
     * Current chosen environment
     */
    environment: string;

    /**
     * Environment setter
     */
    setEnvironment?: Dispatch<SetStateAction<string>>;

    /**
     * Whether access is denied for the current environment
     */
    isAccessDenied: boolean;

    /**
     * Setter for access denied state
     */
    setIsAccessDenied?: Dispatch<SetStateAction<boolean>>;

    /**
     * Whether the environment has been checked via API
     */
    environmentChecked: boolean;

    /**
     * Setter for environment checked state
     */
    setEnvironmentChecked?: Dispatch<SetStateAction<boolean>>;

    /**
     * Whether the environment is valid (passed all checks)
     */
    environmentValid: boolean;

    /**
     * Setter for environment valid state
     */
    setEnvironmentValid?: Dispatch<SetStateAction<boolean>>;
};

export const EnvironmentContext = createContext<EnvironmentsType>({
    environment: "",
    isAccessDenied: false,
    environmentChecked: false,
    environmentValid: false
});

/**
 * Helper function to mark environment as valid only if environment is set
 * @param environment - The current environment URL
 * @param setEnvironmentValid - The setter function for environmentValid
 */
export const markEnvironmentValid = (
    environment: string,
    setEnvironmentValid?: Dispatch<SetStateAction<boolean>>
) => {
    if (environment) {
        setEnvironmentValid?.(true);
    }
};